/*
 * MediSignal — bloc d'offres (snippets/ms-offres.liquid).
 * - La quantité envoyée au panier ne dépend PAS de ce script : les radios name="quantity" sont
 *   associées au formulaire produit par l'attribut form=. Ce script ne fait que :
 *   1. mettre à jour le prix en haut de la fiche (#price-<section>) quand on change d'offre
 *      (au chargement, le serveur a déjà rendu l'offre présélectionnée : snippets/ms-offres-offre.liquid) ;
 *   2. recalculer les montants des cartes si la variante change (variantChange de Dawn) ;
 *   3. gérer le mode « Avec Premium » (mensuel ou annuel) : prix des cartes, encadré « Votre commande comprend »,
 *      et ajout au panier (pack d'étuis au tarif Premium + abonnement Premium avec son plan de vente).
 *
 * Refonte bundle (13/10/2026) :
 * - prix barré = prix barré d'un étui (data-compare-unit, ex. 44,90) × quantité, sur les 3 offres ;
 * - mode Premium mensuel : le prix affiché comprend le 1er mois (pack « offre Premium mensuel », prix = étui −25 % − 4,99 €,
 *   + abonnement 4,99 €/mois) ; prix barré = étuis au prix fort (inchangé) ;
 * - mode Premium annuel : prix affiché = pack « offre Premium » (étui −25 %) + abonnement annuel (data-year-price) ;
 *   prix barré = étuis au prix fort + abonnement annuel. L'économie affichée est donc la même dans les deux plans ;
 * - le choix Mensuel / Annuel est un groupe de boutons [data-ms-plan] sous chaque carte : cliquer coche aussi l'offre.
 * Sans dépendance. Montants en centimes.
 */
(function () {
  if (window.__msOffresLoaded) return;
  window.__msOffresLoaded = true;

  function formatMoney(cents, format) {
    var value = Math.round(Number(cents) || 0);
    function group(amount, decimals, thousands, decimal) {
      var fixed = (amount / 100).toFixed(decimals);
      var parts = fixed.split('.');
      var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? intPart + decimal + parts[1] : intPart;
    }
    var match = format && /\{\{\s*(\w+)\s*\}\}/.exec(format);
    if (!match) {
      try {
        return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(value / 100);
      } catch (e) {
        return (value / 100).toFixed(2).replace('.', ',') + ' €';
      }
    }
    var out;
    switch (match[1]) {
      case 'amount_no_decimals':
        out = group(value, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        out = group(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        out = group(value, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        out = group(value, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        out = group(value, 0, ' ', ',');
        break;
      case 'amount_with_apostrophe_separator':
        out = group(value, 2, "'", '.');
        break;
      default:
        out = group(value, 2, ',', '.');
    }
    return format.replace(match[0], out);
  }

  function intAttr(el, name) {
    return parseInt(el.getAttribute(name), 10) || 0;
  }

  function digits(value) {
    return (value || '').replace(/[^0-9]/g, '');
  }

  function MsOffres(root) {
    this.root = root;
    this.sectionId = root.getAttribute('data-section');
    this.format = root.getAttribute('data-money-format') || '';
    this.unitSuffix = root.getAttribute('data-unit-suffix') || '';
    this.saveLabel = root.getAttribute('data-save-label') || '';
    this.topQtyLabel = root.getAttribute('data-top-qty-label') || '';
    this.updatePrice = root.getAttribute('data-update-price') === 'true';
    this.price = intAttr(root, 'data-price');
    this.priceLocked = root.getAttribute('data-price-locked') === 'true';
    this.compareUnit = Math.max(intAttr(root, 'data-compare-unit'), this.price);
    this.monthPrice = intAttr(root, 'data-month-price');
    this.yearPrice = intAttr(root, 'data-year-price');
    this.shipLabel = root.getAttribute('data-ship-label') || '';
    this.shipPremiumLabel = root.getAttribute('data-ship-premium-label') || '';
    this.radios = Array.prototype.slice.call(root.querySelectorAll('.ms-offres__radio'));

    this.gifts = root.querySelector('[data-ms-gifts]');
    this.subEnabled = root.getAttribute('data-sub-enabled') === 'true';
    this.mode = 'one';
    this.plan = 'month';
    this.subSaveLabel = root.getAttribute('data-sub-save-label') || '';
    this.modeRadios = Array.prototype.slice.call(root.querySelectorAll('.ms-mode__radio'));
    this.planButtons = Array.prototype.slice.call(root.querySelectorAll('[data-ms-plan]'));
    this.subError = root.querySelector('[data-ms-sub-error]');
    this.formId = this.radios.length ? this.radios[0].getAttribute('form') : '';

    var self = this;
    this.radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        self.applyTopPrice();
        self.applyGifts();
      });
    });

    this.modeRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) self.setMode(radio.value);
      });
    });

    this.planButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        self.choosePlan(button);
      });
    });

    // Le navigateur peut restaurer d'autres choix cochés (rechargement, retour arrière) : on resynchronise.
    var restoredMode = null;
    this.modeRadios.forEach(function (r) { if (r.checked) restoredMode = r.value; });
    this.syncPlanButtons();
    if (restoredMode && restoredMode !== this.mode) {
      this.setMode(restoredMode);
    } else {
      this.applyTopPrice();
      this.applyGifts();
    }
  }

  // Achat unique (« one ») ou avec Premium (« sub ») : prix des cartes, prix du haut, textes.
  MsOffres.prototype.setMode = function (mode) {
    this.mode = this.subEnabled && mode === 'sub' ? 'sub' : 'one';
    this.root.classList.toggle('ms-offres--sub', this.mode === 'sub');
    if (this.subError) this.subError.hidden = true;
    this.renderCards();
    this.applyTopPrice();
    this.applyGifts();
  };

  // Clic sur un bouton Mensuel / Annuel d'une carte : coche l'offre de cette carte puis applique le plan à toutes les cartes.
  MsOffres.prototype.choosePlan = function (button) {
    var item = button.closest('.ms-offres__item');
    var radio = item && item.querySelector('.ms-offres__radio');
    if (radio && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
    this.setPlan(button.getAttribute('data-ms-plan'));
  };

  MsOffres.prototype.syncPlanButtons = function () {
    var plan = this.plan;
    this.planButtons.forEach(function (button) {
      button.setAttribute('aria-checked', button.getAttribute('data-ms-plan') === plan ? 'true' : 'false');
    });
  };

  // Premium mensuel (« month ») ou annuel (« year »).
  MsOffres.prototype.setPlan = function (plan) {
    this.plan = plan === 'year' ? 'year' : 'month';
    this.root.classList.toggle('ms-offres--year', this.plan === 'year');
    this.syncPlanButtons();
    if (this.subError) this.subError.hidden = true;
    this.renderCards();
    this.applyTopPrice();
    this.applyGifts();
  };

  MsOffres.prototype.packVariant = function (qty) {
    var attr = this.plan === 'year' ? 'data-sub-pack-year' : 'data-sub-pack';
    var list = (this.root.getAttribute(attr) || '').split(',');
    return digits(list[qty - 1] || '');
  };

  MsOffres.prototype.showSubError = function (msg) {
    if (!this.subError) return;
    this.subError.textContent = msg;
    this.subError.hidden = false;
  };

  // Ajout au panier en mode Premium : pack d'étuis au prix Premium + abonnement Premium (plan de vente mensuel ou annuel).
  MsOffres.prototype.addSubscription = function (form) {
    var self = this;
    var radio = this.checked();
    var qty = radio ? parseInt(radio.value, 10) || 1 : 1;
    var year = this.plan === 'year';
    var premium = digits(this.root.getAttribute(year ? 'data-sub-premium-variant-year' : 'data-sub-premium-variant'));
    var plan = digits(this.root.getAttribute(year ? 'data-sub-selling-plan-year' : 'data-sub-selling-plan'));
    var pack = this.packVariant(qty);
    if (!premium || !plan || !pack) {
      this.showSubError(
        year
          ? 'L’abonnement annuel n’est pas encore disponible. Choisissez « Mensuel » ou « Achat unique ».'
          : 'L’option Premium n’est pas encore disponible. Choisissez « Achat unique ».'
      );
      return;
    }
    var button = form.querySelector('[type="submit"]');
    var spinner = form.querySelector('.loading__spinner');
    if (button) {
      if (button.getAttribute('aria-disabled') === 'true') return;
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
    }
    if (spinner) spinner.classList.remove('hidden');
    if (this.subError) this.subError.hidden = true;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    function done() {
      if (button) {
        button.removeAttribute('aria-disabled');
        button.classList.remove('loading');
      }
      if (spinner) spinner.classList.add('hidden');
    }

    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return { items: [] }; })
      .then(function (current) {
        var hasPremium = (current.items || []).some(function (it) { return String(it.variant_id) === premium; });
        var items = [{ id: Number(pack), quantity: 1 }];
        if (!hasPremium) items.push({ id: Number(premium), quantity: 1, selling_plan: Number(plan) });
        var body = { items: items };
        if (cart && typeof cart.getSectionsToRender === 'function') {
          body.sections = cart.getSectionsToRender().map(function (sec) { return sec.id; });
          body.sections_url = window.location.pathname;
        }
        return fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        }).then(function (r) { return r.json(); });
      })
      .then(function (response) {
        if (!response || response.status) {
          self.showSubError((response && (response.description || response.message)) || 'Ajout impossible, réessayez.');
          return;
        }
        if (!cart || typeof cart.renderContents !== 'function') {
          window.location = (window.routes && window.routes.cart_url) || root + 'cart';
          return;
        }
        response.id = Number(pack);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: Number(pack), cartData: response });
        }
        cart.renderContents(response);
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      })
      .catch(function () {
        self.showSubError('Ajout impossible, vérifiez votre connexion et réessayez.');
      })
      .then(done);
  };

  // Encadré « Vos cadeaux » / « Votre commande comprend » : ligne Premium (achat unique : mois offerts s'il y en a ;
  // Premium : textes mensuel/annuel gérés par le CSS) + livraison (débloquée dès 2 étuis, ou toujours en mode Premium).
  MsOffres.prototype.applyGifts = function () {
    var box = this.gifts;
    var radio = this.checked();
    if (!box || !radio) return;
    var qty = parseInt(radio.value, 10) || 1;
    var months = intAttr(radio, 'data-premium-months');
    var shipFree = radio.getAttribute('data-ship-free') === 'true' || this.mode === 'sub';
    var monthPrice = intAttr(box, 'data-month-price');
    var tpl = box.getAttribute('data-premium-label') || '{mois}';
    var showPremium = this.mode === 'sub' || months > 0;

    var premium = box.querySelector('[data-ms-gift-premium]');
    var plus = box.querySelector('[data-ms-gift-premium-plus]');
    if (premium) premium.hidden = !showPremium;
    if (plus) plus.hidden = !showPremium;
    var label = box.querySelector('[data-ms-gift-premium-label]');
    if (label) label.textContent = tpl.split('{mois}').join(String(months));
    var value = box.querySelector('[data-ms-gift-premium-value]');
    if (value) value.textContent = this.money(monthPrice * months);

    var ship = box.querySelector('[data-ms-gift-ship]');
    if (ship) ship.classList.toggle('is-locked', !shipFree);
    var shipLabel = box.querySelector('[data-ms-gift-ship-label]');
    if (shipLabel && this.shipLabel) {
      shipLabel.textContent = qty >= 2 && this.shipPremiumLabel ? this.shipPremiumLabel : this.shipLabel;
    }
  };

  MsOffres.prototype.priceContainer = function () {
    return document.getElementById('price-' + this.sectionId);
  };

  MsOffres.prototype.checked = function () {
    for (var i = 0; i < this.radios.length; i++) {
      if (this.radios[i].checked) return this.radios[i];
    }
    return null;
  };

  MsOffres.prototype.compute = function (radio) {
    var base = this.computeOne(radio);
    if (this.mode !== 'sub') return base;
    var sub = intAttr(radio, 'data-sub-total');
    if (!(sub > 0)) return base;
    var total, full;
    if (this.plan === 'year') {
      total = sub + this.yearPrice;
      full = base.full + this.yearPrice;
    } else {
      total = sub;
      full = base.full;
    }
    return {
      qty: base.qty,
      full: full,
      total: total,
      save: Math.max(0, full - total),
      unit: Math.round(sub / base.qty),
      showCompare: full > total,
    };
  };

  MsOffres.prototype.computeOne = function (radio) {
    var qty = parseInt(radio.value, 10) || 1;
    var baseTotal = this.price * qty;
    var full = this.compareUnit * qty;
    var setting = intAttr(radio, 'data-total-setting');
    var total = setting > 0 && setting < baseTotal ? setting : baseTotal;
    return {
      qty: qty,
      full: full,
      total: total,
      save: Math.max(0, full - total),
      unit: Math.round(total / qty),
      showCompare: radio.getAttribute('data-show-compare') !== 'false' && full > total,
    };
  };

  // Recalcule les cartes (changement de variante, de mode ou de plan ; au chargement, le Liquid a déjà tout rendu).
  MsOffres.prototype.renderCards = function () {
    var self = this;
    this.radios.forEach(function (radio) {
      var o = self.compute(radio);
      var card = radio.nextElementSibling;
      if (!card) return;
      var hasSave = o.showCompare && o.save > 0;
      var total = card.querySelector('[data-ms-total]');
      var compare = card.querySelector('[data-ms-compare]');
      var compareValue = card.querySelector('[data-ms-compare-value]');
      var unit = card.querySelector('[data-ms-unit]');
      var save = card.querySelector('[data-ms-save]');
      if (total) total.textContent = self.money(o.total);
      if (unit) unit.textContent = self.money(o.unit) + (self.unitSuffix ? ' ' + self.unitSuffix : '');
      if (compare) compare.hidden = !hasSave;
      if (compareValue) compareValue.textContent = self.money(o.full);
      if (save) {
        save.hidden = !hasSave;
        save.textContent = (self.mode === 'sub' && self.subSaveLabel ? self.subSaveLabel : self.saveLabel).replace('{montant}', self.money(o.save));
      }
      card.classList.toggle('ms-offres__card--has-save', hasSave && !!save);
    });
  };

  MsOffres.prototype.money = function (cents) {
    return formatMoney(cents, this.format);
  };

  // Prix du haut : total de l'offre cochée, barré si économie > 0. Même rendu que la sortie 'top' de ms-offres-offre.liquid.
  MsOffres.prototype.applyTopPrice = function () {
    if (!this.updatePrice || !document.body.contains(this.root)) return;
    var container = this.priceContainer();
    var radio = this.checked();
    var wrap = container && container.querySelector('.msid-price');
    if (!wrap || !radio) return;

    var o = this.compute(radio);
    var withCompare = o.showCompare && o.save > 0;
    var key = o.qty + '|' + o.total + '|' + (withCompare ? o.full : '') + (this.mode === 'sub' ? '|sub-' + this.plan : '');
    if (wrap.getAttribute('data-ms-key') === key) return; // déjà à jour : pas de réécriture, pas d'annonce role=status

    var badgeText = wrap.getAttribute('data-ms-badge') || '';
    var soldout = wrap.querySelector('.msid-price__badge--soldout');
    soldout = soldout ? soldout.cloneNode(true) : null;

    var frag = document.createDocumentFragment();
    var current = document.createElement('span');
    current.className = 'msid-price__current';
    current.textContent = this.money(o.total);
    frag.appendChild(current);
    if (withCompare) {
      var s = document.createElement('s');
      s.className = 'msid-price__compare';
      var hidden = document.createElement('span');
      hidden.className = 'visually-hidden';
      hidden.textContent = 'Au lieu de ';
      s.appendChild(hidden);
      s.appendChild(document.createTextNode(this.money(o.full)));
      frag.appendChild(s);
    }
    if (badgeText) {
      var badge = document.createElement('span');
      badge.className = 'msid-price__badge';
      badge.textContent = badgeText;
      frag.appendChild(badge);
    }
    if (soldout) frag.appendChild(soldout);
    if (this.topQtyLabel) {
      var card = radio.nextElementSibling;
      var titleEl = card && card.querySelector('.ms-offres__title');
      var title = titleEl ? titleEl.textContent.trim() : String(o.qty);
      var qtyLabel = document.createElement('span');
      qtyLabel.className = 'msid-price__ms-qty';
      qtyLabel.textContent = this.topQtyLabel.split('{offre}').join(title).split('{qty}').join(String(o.qty));
      frag.appendChild(qtyLabel);
    }

    wrap.className = 'msid-price msid-price--sale';
    wrap.setAttribute('data-ms-key', key);
    wrap.textContent = '';
    wrap.appendChild(frag);
  };

  // Changement de variante : product-info.js vient de réécrire #price-<section> avec le rendu serveur ;
  // on recalcule les cartes puis l'offre cochée.
  MsOffres.prototype.onVariantChange = function (variant) {
    if (variant && typeof variant.price === 'number' && !this.priceLocked) {
      this.price = variant.price;
      this.compareUnit = Math.max(this.compareUnit, this.price);
      this.root.setAttribute('data-price', String(variant.price));
      this.renderCards();
    }
    this.applyTopPrice();
  };

  var instances = [];

  function initAll() {
    instances = instances.filter(function (inst) {
      return document.body.contains(inst.root);
    });
    var roots = document.querySelectorAll('[data-ms-offres]');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].__msOffres) continue;
      roots[i].__msOffres = new MsOffres(roots[i]);
      instances.push(roots[i].__msOffres);
    }
  }

  function subscribeVariantChange() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = (event && event.data) || {};
      initAll();
      instances.forEach(function (inst) {
        if (!data.sectionId || data.sectionId === inst.sectionId) inst.onVariantChange(data.variant);
      });
    });
  }

  // Mode Premium : on intercepte l'envoi du formulaire produit AVANT product-form.js (phase de capture sur document).
  function onSubmitCapture(event) {
    var form = event.target;
    var formId = form && form.getAttribute ? form.getAttribute('id') : '';
    if (!formId) return;
    for (var i = 0; i < instances.length; i++) {
      var inst = instances[i];
      if (inst.mode === 'sub' && inst.formId === formId && document.body.contains(inst.root)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        inst.addSubscription(form);
        return;
      }
    }
  }

  function start() {
    document.addEventListener('submit', onSubmitCapture, true);
    initAll();
    subscribeVariantChange();
    // Un seul écouteur pour toutes les instances (bfcache / retour arrière) ; les instances détachées sont filtrées.
    window.addEventListener('pageshow', function () {
      initAll();
      instances.forEach(function (inst) {
        inst.applyTopPrice();
      });
    });
    // Éditeur de thème : la section est re-rendue sans recharger la page.
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', initAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
